// @flow
/* eslint-disable react/no-unknown-property */
import styled from '@emotion/styled';
import type { BlokComponentPropsType } from '../types';

export type PropsType = BlokComponentPropsType<{
  url: string
}>;

const Wrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;

  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

function convert(url: string) {
  // in https://youtu.be/fzQ6gRAEoy0
  // out https://youtube.com/embed/fzQ6gRAEoy0
  const parts = url.split('/');
  return `https://youtube.com/embed/${
    parts[parts.length - 1]
  }?modestbranding=1`;
}

const YoutubeVideo = ({ blok: { url } }: PropsType) => (
  <Wrapper>
    <iframe
      width="895"
      height="480"
      title="youtube video"
      src={convert(url)}
      frameborder="0"
      allowfullscreen
    />
  </Wrapper>
);

export default YoutubeVideo;
